import * as React from 'react';
import { connect } from 'react-redux';
import { getQuestionnaireEvaluationQuestionAttributeType } from "../../questionnaireEvaluation";
import { getCapturedUploadPhotoFiles, getIntelligentSequenceScreenName, getIntelligentPhotoCaptureImageDetail, getIntelligentPhotoCaptureserviceFailStatus } from '../selectors';
import { photoCaptureIntelligentViewChangeAction } from '../actions';
import { IntelligentPhotoCaptureImageAnalyzerView } from '../components';
const mapStateToProps = (state) => ({
    imageAnalyzerData: getIntelligentPhotoCaptureImageDetail(state),
    files: getCapturedUploadPhotoFiles(state),
    questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
    sequenceScreenName: getIntelligentSequenceScreenName(state),
    serviceFailStatus: getIntelligentPhotoCaptureserviceFailStatus(state)
});
const mapDispatchToProps = (dispatch) => ({
    onViewChange: (view, sequenceScreenName) => {
        dispatch(photoCaptureIntelligentViewChangeAction(view, sequenceScreenName));
    }
});
export const IntelligentPhotoCaptureImageAnalyzerViewWrapper = (props) => {
    return React.createElement(IntelligentPhotoCaptureImageAnalyzerView, Object.assign({}, props));
};
export const ConnectedIntelligentPhotoCaptureImageAnalyzerView = connect(mapStateToProps, mapDispatchToProps)(IntelligentPhotoCaptureImageAnalyzerViewWrapper);
//# sourceMappingURL=ConnectedIntelligentPhotoCaptureImageAnalyzerView.js.map